import React, { Component } from 'react'
import Link from '../utils/link'

class Support extends Component {

  state = {
    category: 'all',
    more: false,
  }

  render() {

    let { category, more } = this.state

    let { title, categories, items } = this.props

    return (
      <section className='our-partnerships-block support'>
        <div className='our-partnerships-block__inner'>
          <h3 className='support__title' dangerouslySetInnerHTML={{ __html: title }} />
          <div className='our-partnerships-block__content'>
            <div className='our-partnerships-block__menu'>
              { categories &&
                <ul>
                  <li className={`${category === 'all' ? 'active' : ''}`}>
                    <button type='button' onClick={() => this.setState({ category: 'all' })}>All</button>
                  </li>
                  { categories.map((el, i) => (
                    <li className={`${category === el.name ? 'active' : ''}`} key={i}>
                      <button type='button' onClick={() => this.setState({ category: el.name })}>{el.title}</button>
                    </li>
                  ))}
                </ul>
              }
            </div>
            <div className='our-partnerships-block__components'>
              { items?.length > 0 && 
                <div className='community-efforts'>
                  <div className='community-efforts__content'>
                    { items &&
                      <div className={`community-efforts__items ${(more || category !== 'all') ? 'show-more' : ''}`}>
                        { items.map((el, i) => (
                          <div className={`community-efforts__item ${(category === el.category || category === 'all') ? 'active' : ''}`} key={i}>
                            <h4 className='heading' dangerouslySetInnerHTML={{ __html: el.title }} />
                            <div className='copy' dangerouslySetInnerHTML={{ __html: el.content }} />
                            { el.link &&
                              <Link to={el.link}>{ el.text }</Link>
                            }
                          </div>
                        ))}
                      </div>
                    }
                    { !more && category === 'all' &&
                      <button className='support__view-more btn' onClick={() => this.setState({ more: true })}>
                        View More
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Support
